import React from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { FormControl, FormHelperText, Typography } from '@mui/material';

export const RichTextEditor = ({ label, value, onChange, error }) => {
  return (
    <FormControl fullWidth margin="normal" error={!!error}>
      {label && <Typography variant="label">{label}</Typography>}

      <div
        style={{
          border: '1px solid #ccc',
          borderRadius: 4,
          overflow: 'hidden',
        }}
      >
        <CKEditor
          editor={ClassicEditor}
          data={value || ''}
          onChange={(_, editor) => onChange(editor.getData())}
          config={{
            placeholder: 'Digite aqui...',
          }}
        />
      </div>

      {error && <FormHelperText>{error.message}</FormHelperText>}
    </FormControl>
  );
};
